import { render, staticRenderFns } from "./ValidationSummary.vue?vue&type=template&id=ba8fbfd6&"
import script from "./ValidationSummary.vue?vue&type=script&lang=ts&"
export * from "./ValidationSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports